var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "tab2" } },
    [
      _c(
        "div",
        { staticClass: "row custom-container-search" },
        [
          _c("filter-list", {
            attrs: { "rol-name": "rol", "user-name": "user" }
          })
        ],
        1
      ),
      _c("tab-item-card", { attrs: { "status-class": "green" } }, [
        _c("div", { attrs: { slot: "body" }, slot: "body" }, [
          _c("div", { staticClass: "d-flex jusitfy-content-between" }, [
            _c("div", { staticClass: "row col-12" }, [
              _c("div", { staticClass: "col-3 p-0" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", { staticClass: "data-title" }, [
                    _vm._v("Nombre:")
                  ]),
                  _c("span", { staticClass: "data-content" }, [
                    _vm._v("Johans Cuéllar")
                  ])
                ])
              ]),
              _c("div", { staticClass: "custom-information-divider" }),
              _c("div", { staticClass: "col-2 p-0" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", { staticClass: "data-title" }, [
                    _vm._v("Usuario:")
                  ]),
                  _c("span", { staticClass: "data-content" }, [
                    _vm._v("jcuellar")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-2 p-0" }, [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("span", { staticClass: "data-title" }, [_vm._v("Rol:")]),
                  _c("span", { staticClass: "data-content" }, [_vm._v("Admin")])
                ])
              ]),
              _c("div", { staticClass: "col-2 p-0" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    _c("span", { staticClass: "data-title" }, [
                      _vm._v("Tipo de Propuesta:")
                    ]),
                    _c("custom-drop-down", {
                      staticClass: "custom-drop-down",
                      attrs: {
                        clearable: false,
                        fieldkey: "id",
                        fieldname: "description",
                        placeholder: "Seleccione"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-2 custom-container-provider p-0" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column" },
                    [
                      _c("span", { staticClass: "data-title" }, [
                        _vm._v("Tipo de Proveedores:")
                      ]),
                      _c("custom-drop-down", {
                        staticClass: "custom-drop-down",
                        attrs: {
                          clearable: false,
                          fieldkey: "id",
                          fieldname: "description",
                          placeholder: "Seleccione"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ]),
        _c(
          "div",
          { attrs: { slot: "actions" }, slot: "actions" },
          [
            _c("action-button", {
              staticClass: "fr px-4 custom-btn-add",
              attrs: { i: "fa fa-times-circle", text: "Añadir" }
            })
          ],
          1
        )
      ]),
      _c("pagination", { staticClass: "custom-pagination" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }